import getDevice from '../../envs/getDevice'
import { getPageViewData } from './helpers'

export default ({ data = {} }) => {
  const { pageCategory, pageName } = getPageViewData()

  console.log('[ Segment ] - PageView')
  const device = getDevice.device()

  window.analytics.page(
    pageCategory,
    pageName,
    {
      url: data.location.href,
      path: data.location.pathname
    },
    { device }
  )
}
